import React from 'react';
import OrdersFormatter from '../../components/OrdersFormatter';
import AddressFormatter from '@afosto/utils-react/formatters/AddressFormatter';
import ProductImageFormatter from '@afosto/utils-react/formatters/ProductImageFormatter';
import ProductSkuFormatter from '@afosto/utils-react/formatters/ProductSkuFormatter';
import ShipmentsFormatter from '@afosto/utils-react/formatters/ShipmentsFormatter';

export const addressFormatter = cell => <AddressFormatter addressId={cell} />;

export const ordersFormatter = cell => <OrdersFormatter orderIds={cell} />;

export const productImageFormatter = (cell, row) => <ProductImageFormatter sku={row?.sku} />;

export const productSkuFormatter = cell => <ProductSkuFormatter sku={cell} />;

export const shipmentsFormatter = cell => <ShipmentsFormatter shipmentIds={cell} />;

export const targetFormatter = cell => <OrdersFormatter orderIds={cell ? [cell] : []} />;

export default ordersFormatter;
